import styled from 'styled-components';
import fonts from '../../helpers/fonts';
import mediaQuery from '../../helpers/mediaQuery';
import spacing from '../../helpers/spacing';
import { Grid, GridItem } from '../Grid';

export const TestimonialWrapper = styled.div`
  margin-top: ${spacing(8)};
  margin-bottom: ${spacing(8)};

  ${mediaQuery.tabletPortrait`
    margin-top: ${spacing(12)};
    margin-bottom: ${spacing(12)};
  `}
`;

export const GridItemFlex = styled(GridItem)`
  display: flex;
`;

export const TestimonialGrid = styled(Grid)`
  && {
    margin-bottom: ${spacing(-4)};
  }
`;

export const Heading = styled.h3`
  margin: 0 0 ${spacing(8)};
  ${fonts.headingLarge};
`;
